<template>
  <div>
    <section id="home" class="mainBackground">
      <v-container fluid pa-0>
        <div class="content pa-lg-16 pa-8">
          <v-row no-gutters wrap align="start">
            <v-col sm="12" md="6" lg="5">
              <div class="white--text tagline">
                <v-flex align-self-center>
                  <div class="ma-2 display-2 font-weight-bold">Ingin Donasi di Masjid Anda lebih besar dan mudah?</div>
                  <div class="ma-2 subtitle-1">
                    Kami bisa membantu Anda. Urusan masjid jadi mudah!<br> Platform pertama untuk digitalisasi
                    masjid di Indonesia!<br>
                    <v-btn class="teal--text text--darken-3 mt-2">read more</v-btn>
                  </div>  
                </v-flex>
              
                <router-view />
              </div>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </section>
    <section id="feature">
      <HomeFeature />
    </section>
    <section id="about">
      <HomeAbout />
    </section>
    <section id="register">
      <HomeRegister />
    </section>
    <section id="faq">
      <HomeFAQ />
    </section>
    <section id="footer">
      <HomeFooter />
    </section>
  </div>
</template>

<style scoped>
  .mainBackground {
    background-image: url('../assets/group53.png');
    height: 700px;
    width: 100%;
    background-position: center;
    background-size: cover;
  }
  .tagline {
    margin-top: 100px;
  }
</style>

<script>
  import HomeAbout from "@/views/Home/HomeAbout";
  import HomeFeature from "@/views/Home/HomeFeature";
  import HomeRegister from "@/views/Home/HomeRegister";
  import HomeFAQ from "@/views/Home/HomeFAQ";
  import HomeFooter from "@/views/Home/HomeFooter";

  export default {
    components: {
      HomeAbout,
      HomeFeature,
      HomeRegister,
      HomeFAQ,
      HomeFooter
    },
    data() {
      return {

      }
    }
  }
</script>